export default __webpack_public_path__ + "static/media/Diamond_Edge_large_3.7a9574c2.jpg";